import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function ValueStack() {
  const items = [{
    name: 'Manual completo "El Fuego que Nadie Ve" (55 páginas)',
    value: '$7 USD'
  }, {
    name: 'Lista de compras maestra con costos reales',
    value: '$9 USD'
  }, {
    name: 'Guía de preparación de la Pasta de Oro',
    value: '$9 USD'
  }, {
    name: 'Los 4 movimientos matinales en video ilustrado',
    value: '$9 USD'
  }, {
    name: 'Acceso inmediato por descarga digital',
    value: 'Gratis'
  }];
  return <section className="bg-dark-green py-20 px-6 md:px-12 lg:px-24 text-white" data-id="element-295">
      <div className="max-w-3xl mx-auto" data-id="element-296">
        <FadeIn data-id="element-297">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gold mb-12" data-id="element-298">
            Todo lo que recibes hoy:
          </h2>
        </FadeIn>

        <div className="bg-white/5 rounded-2xl border border-gold/30 overflow-hidden" data-id="element-299">
          <div className="p-6 md:p-8 space-y-6" data-id="element-300">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-301">
                <div className="flex items-center justify-between border-b border-white/10 pb-4 last:border-0 last:pb-0" data-id="element-302">
                  <div className="flex items-center gap-4" data-id="element-303">
                    <div className="bg-sage/20 p-1 rounded-full" data-id="element-304">
                      <Check className="text-sage" size={20} data-id="element-305" />
                    </div>
                    <span className="text-lg md:text-xl" data-id="element-306">{item.name}</span>
                  </div>
                  <span className="text-lg md:text-xl font-bold text-gold ml-4 whitespace-nowrap" data-id="element-307">
                    {item.value}
                  </span>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-308">
            <div className="bg-gold/20 p-6 md:p-8 flex items-center justify-between border-t border-gold/30" data-id="element-309">
              <span className="text-2xl md:text-3xl font-serif font-bold" data-id="element-310">
                VALOR TOTAL
              </span>
              <span className="text-2xl md:text-3xl font-bold text-gold line-through decoration-red-500/70 decoration-4" data-id="element-311">
                $34 USD
              </span>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}